/* repo/processor*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString
} from "./api";
import { ProcessorCodec, Processor, Data } from "../store/processor/types";
import { withDecoded, flattenData } from "./";

export function getNewProcessor(): Data {
  return {
    id: null,
    type: "Processor",
    attributes: {
      Name: "",
      FIIC: "",
      Bin: [],
      Host: "",
      AdditionalData: []
    }
  };
}

function mapToModel(data: object): Processor {
  return withDecoded(ProcessorCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(
  id: string | null,
  params?: {}
): Promise<Processor> {
  return fetchApi({
    nestedResourcePath: ["processor"],
    id: id,
    params: params
  }).then(response =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(processor: Data): Promise<Processor> {
  return insertApi({
    nestedResourcePath: ["processor"],
    id: processor.id,
    data: { data: processor }
  }).then(response =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["processor"],
    id: id
  }).then(() => true);
}
